
import { React, Component } from 'react'
import { Link } from 'react-router-dom';
import ApiSso from '../../actions/sso';
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import SelectedPlan from '../../components/SelectedPlan/SelectedPlan';
import Steps from '../../components/Steps/Steps';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css'

class PasswordRecovery extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: 2,
            email: '',
            isLoading: false,
            isSuccess: false
        }
        this.auth = this.auth.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);

    }

    auth() {
        const client = process.env.REACT_APP_CLIENT;
        const key = process.env.REACT_APP_KEY;

        return ApiSso.post('client', {
            'client': client,
            'key': key
        });
    }

    componentDidMount(){
        
        this.setState({
            isLoading: false,
            isSuccess: false,
        });

    }

    sendEmail(token) {
        ApiSso.defaults.headers.common['Authorization'] = token;
        return ApiSso.post('user/password_forgot', {
            'email': this.state.email
        });
    }

    handleForgotPassword(event) {
        this.setState({isLoading: true});

        this.auth().then(authResponse => {
            this.sendEmail(authResponse.data.data.token).then(response => {
                this.setState({
                    isLoading: false,
                    isSuccess: true,
                });
            }).catch(error => {
                if (!error.response.data.data.exist) {
                    this.setState({
                        isLoading: false,
                        isSuccess: false,
                    })
                }
            });
        }).catch(error => {

            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 60000
            }
            toastr.clear()
            setTimeout(() => toastr.error('Falha na autenticação do SSO.'), 300)
            return;

        });
    }

    render(){
        return(
        <div>

            {/* <SelectedPlan /> */}

            {this.state.isLoading ? (
                <LoadingComponent />
            ) : (
                this.state.isSuccess ? (
                    <div className="position-relative">
                        <div className="p-5">
                            <form onSubmit={event => this.handleLogin(event)} className="text-center form login-form">
                                <h4 className="mb-3">Um link foi enviado para</h4>
                                <input type="email" className="form-control disabled text-center" disabled value={this.state.email} onChange={(e) => {this.setState({email: e.target.value})}} placeholder="Digite seu e-mail" />
                                <small>Clique no link enviado para fazer sua alteração de senha</small><br /><br />
                                <Link to="/login" className="form-submit">Voltar ao login</Link>
                            </form>
                        </div>
                    </div>
                ) : (
                    <div className="position-relative">
                        <div className="p-5">
                            <form onSubmit={event => this.handleForgotPassword(event)} className="text-center form login-form">
                                <h4 className="mb-3">Digite seu e-mail</h4>
                                <input type="email" className="form-control disabled text-center" value={this.state.email} onChange={(e) => {this.setState({email: e.target.value})}} placeholder="Digite seu e-mail" />
                                <small>Iremos enviar um link para concluir a verificação</small><br /><br />
                                <input type="submit" className="form-submit" value="Recuperar senha" />
                            </form>
                        </div>
                    </div>
                )
            ) }

            
        </div>
        )
    }
}

export default PasswordRecovery